export var HostType;
(function (HostType) {
    HostType["Classic"] = "editor";
    HostType["Editorx"] = "editor_x";
    HostType["Studio"] = "studio";
    HostType["Editor3"] = "editor3";
    HostType["MobileStudio"] = "mobile_app_builder";
})(HostType || (HostType = {}));
//# sourceMappingURL=types.js.map